import { DataSetAtom, MeasuresRaw, MeasureType } from '@/store'
import { MeasureAtom, MeasureUnit, unit } from '@/store/measure'
import { Group, Ctrl } from '@/components/control-panl'
import { Measure, StartMeasure } from '@/sdk'
import { round } from '@/utils/index'
import { reactive } from 'vue'
import { ui18n } from '@/lang'

export { MeasureUnit } from '@/store/measure'

type Desc = { [key in MeasureUnit]: string }
export const unitDesc: Desc = {
  [MeasureUnit.meter]: ui18n.t('measure.unit.meter'),
  [MeasureUnit.inch]: ui18n.t('measure.unit.inch')
}

type Options = Array<{ value: MeasureUnit; label: Desc[MeasureUnit] }>
export const unitOptions: Options = [
  { value: MeasureUnit.meter, label: unitDesc[MeasureUnit.meter] },
  { value: MeasureUnit.inch, label: unitDesc[MeasureUnit.inch] }
]
export type TSetMeasureAtom = ({type: 'measure', data:  MeasureAtom} | 
    {type: 'buffer', data:  MeasureAtom['buffers'][0], parent: MeasureAtom })

export type SetMeasureAtom = Omit<DataSetAtom, 'children'> & {
  children: TSetMeasureAtom[]
}
export type SetMeasures = Array<SetMeasureAtom>

export type Types = MeasureType
export const infos = {
  LINE: { name: ui18n.t('measure.len'), icon: 'f-l' } as const,
  SERIES: { name: ui18n.t('measure.len'), icon: 'icon_f_z_n' } as const,
  AREA: { name: ui18n.t('measure.area'), icon: 'f-m' } as const,
  L_LINE: { name: ui18n.t('measure.len'), icon: 'h-l' } as const,
  L_SERIES: { name: ui18n.t('measure.len'), icon: 'icon_h_z_n' } as const,
  L_AREA: { name: ui18n.t('measure.area'), icon: 'h-m' } as const,
  L_RECTANGLE: { name: ui18n.t('measure.area'), icon: 'h-r' } as const,
  V_LINE: { name: ui18n.t('measure.len'), icon: 'v-l' } as const,
  V_SERIES: { name: ui18n.t('measure.len'), icon: 'icon_v_z_n' } as const,
  V_AREA: { name: ui18n.t('measure.area'), icon: 'v-m' } as const,
  V_RECTANGLE: { name: ui18n.t('measure.area'), icon: 'v-r' } as const
} as const
type InfoType = (typeof infos)[Types]['name']

export type CtrlType = Types | 'magnifier' | 'viewMode'
export type CtrlAtom = Ctrl & { value: CtrlType; key?: string; guide?: string }

export const ctrolGroup = reactive([
  {
    ctrls: [
      {
        icon: 'magnify',
        value: 'magnifier',
        makeup: true,
        desc: ui18n.t('tool.magnify')
      }
    ]
  },
  {
    apart: true,
    label: ui18n.t('tool.free'),
    ctrls: [
      {
        icon: infos['LINE'].icon,
        value: 'LINE',
        desc: infos['LINE'].name
      },
      {
        icon: infos['SERIES'].icon,
        value: 'SERIES',
        desc: ui18n.t('tool.series')
      },
      { icon: infos['AREA'].icon, value: 'AREA', desc: ui18n.t('tool.area') }
    ]
  },
  {
    label: ui18n.t('tool.lfree'),
    ctrls: [
      {
        icon: infos['L_LINE'].icon,
        value: 'L_LINE',
        desc: infos['L_LINE'].name
      },
      {
        icon: infos['L_SERIES'].icon,
        value: 'L_SERIES',
        desc: ui18n.t('tool.series')
      },
      {
        icon: infos['L_RECTANGLE'].icon,
        value: 'L_RECTANGLE',
        desc: ui18n.t('tool.rect')
      },
      {
        icon: infos['L_AREA'].icon,
        value: 'L_AREA',
        desc: ui18n.t('tool.area')
      }
    ]
  },
  {
    label: ui18n.t('tool.vfree'),
    ctrls: [
      {
        icon: infos['V_LINE'].icon,
        value: 'V_LINE',
        desc: infos['V_LINE'].name
      },
      {
        icon: infos['V_SERIES'].icon,
        value: 'V_SERIES',
        desc: ui18n.t('tool.series')
      },
      {
        icon: infos['V_RECTANGLE'].icon,
        value: 'V_RECTANGLE',
        desc: ui18n.t('tool.rect')
      },
      {
        icon: infos['V_AREA'].icon,
        value: 'V_AREA',
        desc: ui18n.t('tool.area')
      }
    ]
  },
  {
    ctrls: [
      {
        icon: 'a-2d',
        value: 'viewMode',
        makeup: true
      }
    ],
    apart: true
  }
]) as Group<CtrlAtom>

export type CanvasMeasureAtom = { raw: MeasureAtom; canvas: Measure }
export type CanvasMeasures = Array<CanvasMeasureAtom>
export type TempCanvasMeasureAtom = Omit<CanvasMeasureAtom, 'canvas'> & {
  canvas: StartMeasure
}

export type MeasureLocal = [DataSetAtom, MeasureAtom]
export type MeasureShareAtom = {
  measure: CanvasMeasureAtom
  local: MeasureLocal
}
export type ShareMeasures = Array<MeasureShareAtom>

export const getUnit = (item: CanvasMeasureAtom) => {
  const key = unit.value === MeasureUnit.meter ? 'value' : 'string'
  const type = infos[item.raw.type].name
  const origin =
    type === ui18n.t('measure.len')
      ? item.canvas.getDistance()
      : item.canvas.getArea()
  const buffers = type === ui18n.t('measure.len') ? [] : item.canvas.getBufferAreas()
  // const buffers: string[] = ['111']  
  console.log(origin)

  if (origin) {
    // const val = key === 'value' ? (type === ui18n.t('measure.len') ? `${round(origin[key], 2)} m` : `${round(origin[key], 2)} m²`) : origin[key]
    return {
      origin: origin.string,
      buffers: buffers.map(s => s.string)
    }
  } else {
    return {
      origin: '0',
      buffers: []
    }
  }
}
